import React from "react";
import { Row } from "antd";

export const PageGap = () => {
  return <Row className="full-row big-page-gap"></Row>;
};
